/*
 * Brightside slide-out cart.
 * Markup: snippets/drawer-cart, bs-cart-drawer-body, bs-cart-drawer-footer.
 * Every change goes through Shopify's cart API with the theme's sections attached, then
 * hands the response to the theme ('shapes:cart:update') so its own morphing, cart count
 * and theme events keep working. Settings: Content > Metaobjects > Cart drawer settings.
 */
(function () {
  'use strict';
  if (window.BrightsideCart) return;

  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var RATE_ADDRESS =
    'shipping_address%5Bzip%5D=6000&shipping_address%5Bcountry%5D=Australia&shipping_address%5Bprovince%5D=Western%20Australia';
  // [x, y, rotation, colour, width, height, radius]
  var CONFETTI = [
    [-4, -27, 0, '#ff94b5', 8, 8, '999px'],
    [26, -27, 47, '#a1dceb', 6, 12, '2px'],
    [42, -24, 94, '#fcfcd4', 8, 8, '999px'],
    [34, 4, 141, '#ff94b5', 6, 12, '2px'],
    [39, 14, 188, '#a1dceb', 8, 8, '999px'],
    [19, 39, 235, '#1a1c4d', 6, 12, '2px'],
    [4, 27, 282, '#ff94b5', 8, 8, '999px'],
    [-26, 27, 329, '#a1dceb', 6, 12, '2px'],
    [-42, 24, 16, '#fcfcd4', 8, 8, '999px'],
    [-34, -4, 63, '#ff94b5', 6, 12, '2px'],
    [-39, -14, 110, '#a1dceb', 8, 8, '999px'],
    [-19, -39, 157, '#1a1c4d', 6, 12, '2px']
  ];

  var cfg = null;
  var state = {
    busy: false,
    removed: null,
    prevTotal: null,
    rates: {},
    ratesSeq: 0,
    noteOpen: null,
    refocus: null,
    flashKey: null,
    codeError: '',
    toastTimer: null,
    noteTimer: null,
    giftLock: false,
    // null until the shopper opens or closes the summary themselves; after that we leave it alone
    sumManual: null,
    // true while the summary is folded because the shopper scrolled down (phones)
    sumScrolled: false,
    // The cart's discount codes as Shopify last reported them ([{code, applicable}]), and the
    // free-shipping code that's on, if any (see syncCodes)
    codes: null,
    codesFresh: false,
    codesSeq: 0,
    codesTimer: null,
    shipCode: null,
    // set when a typed code goes on, so the phone keyboard can be put away after the re-render
    codeAccepted: false
  };

  /* ---------- helpers ---------- */
  function config() {
    if (cfg) return cfg;
    try {
      cfg = JSON.parse(document.getElementById('bs-cart-config').textContent);
    } catch (e) {
      cfg = {};
    }
    cfg.freeAt = +cfg.freeAt || 7500;
    cfg.giftAt = +cfg.giftAt || 10000;
    return cfg;
  }
  function rootUrl() {
    var r = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }
  function q(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function attr(value) {
    return String(value).replace(/["\\]/g, '\\$&');
  }
  function drawer() {
    return q('[data-cart-drawer]');
  }
  function body() {
    return q('[data-bs-body]');
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }
  function drawerVisible() {
    var d = drawer();
    return !!(d && d.offsetParent !== null && d.getBoundingClientRect().width > 0);
  }

  /* ---------- cart API ---------- */
  function post(path, payload, withSections) {
    var data = Object.assign({}, payload);
    if (withSections !== false) {
      data.sections = SECTIONS;
      data.sections_url = window.location.pathname;
    }
    return fetch(rootUrl() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (json) {
          if (!res.ok || json.status) {
            var err = new Error(json.description || json.message || 'Something went wrong. Please try again.');
            err.data = json;
            throw err;
          }
          return json;
        });
    });
  }
  function change(key, quantity, extra) {
    return post('cart/change.js', Object.assign({ id: key, quantity: quantity }, extra || {}));
  }
  function add(items) {
    return post('cart/add.js', { items: items });
  }
  function update(payload) {
    return post('cart/update.js', payload);
  }
  function render(response) {
    if (!response || !response.sections) return;
    document.body.dispatchEvent(
      new CustomEvent('shapes:cart:update', { bubbles: true, detail: { response: response } })
    );
  }

  /* ---------- busy / errors ---------- */
  function setBusy(on, line) {
    var d = drawer();
    if (d) {
      d.classList.toggle('is-busy', on);
      d.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    if (line && line.isConnected) line.classList.toggle('is-busy', on);
  }
  function clearErrors() {
    qa('[data-bs-error]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    var box = document.getElementById('cart-errors');
    if (box) box.textContent = '';
  }
  function showError(line, message) {
    var el = line && line.isConnected ? q('[data-bs-error]', line) : null;
    if (el) {
      el.textContent = message;
      el.hidden = false;
      return;
    }
    var box = document.getElementById('cart-errors');
    if (box) box.textContent = message;
  }
  function codeError(message) {
    var el = q('[data-bs-code-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function run(task, line, refocus, background) {
    if (state.busy) return Promise.resolve(false);
    state.busy = true;
    // Any other change the shopper makes moves on from the last removal, so its notice goes
    if (!background) hideToast();
    state.refocus = refocus || null;
    clearErrors();
    setBusy(true, line);
    return task()
      .then(function (res) {
        // Update and change responses carry the cart's codes; add responses don't (afterRender
        // fetches them then)
        if (res && Array.isArray(res.discount_codes)) {
          state.codes = res.discount_codes;
          state.codesFresh = true;
          state.codesSeq++;
        }
        render(res);
        return true;
      })
      .catch(function (err) {
        state.refocus = null;
        showError(line, err.message);
        return false;
      })
      .then(function (ok) {
        state.busy = false;
        setBusy(false, line);
        return ok;
      });
  }

  /* ---------- actions ---------- */
  function lineOf(el) {
    return el.closest('[data-bs-line]');
  }
  function lineItem(line) {
    var props = {};
    try {
      props = JSON.parse(line.getAttribute('data-properties') || '{}') || {};
    } catch (e) {
      props = {};
    }
    var item = { id: +line.getAttribute('data-variant-id'), quantity: +line.getAttribute('data-qty') || 1 };
    if (props && Object.keys(props).length) item.properties = props;
    if (line.getAttribute('data-plan-id')) item.selling_plan = +line.getAttribute('data-plan-id');
    return item;
  }
  function keepNewKey(res) {
    if (res && res.items && res.items[0]) state.flashKey = res.items[0].key;
    return res;
  }

  /* One row in the drawer can be several cart lines: the free gift discount (Buy X Get Y) splits
     a line into the units that count towards it and the rest (see bs-cart-drawer-body). These
     change every line in the row together. */
  function keysOf(line) {
    var keys = (line.getAttribute('data-keys') || '').split(/\s+/).filter(Boolean);
    return keys.length ? keys : [line.getAttribute('data-key')];
  }
  function lineWithKey(key) {
    return q('[data-bs-line][data-keys~="' + attr(key) + '"]') || q('[data-bs-line][data-key="' + attr(key) + '"]');
  }
  function setQty(line, quantity) {
    var keys = keysOf(line);
    if (keys.length < 2) return change(keys[0], quantity);
    var updates = {};
    keys.forEach(function (k, i) {
      updates[k] = i === 0 ? quantity : 0;
    });
    return update({ updates: updates });
  }
  function clearLines(keys) {
    if (keys.length < 2) return change(keys[0], 0);
    var updates = {};
    keys.forEach(function (k) {
      updates[k] = 0;
    });
    return update({ updates: updates });
  }
  function propsSig(props) {
    props = props || {};
    return JSON.stringify(
      Object.keys(props)
        .sort()
        .map(function (k) {
          return [k, props[k]];
        })
    );
  }
  // Subscribe, unsubscribe or change frequency: the whole row moves to the new plan on its first
  // line, then whatever's left on the old plan (the rest of a split row) comes out.
  function replan(line, plan) {
    var keys = keysOf(line);
    var qty = +line.getAttribute('data-qty');
    var vid = +line.getAttribute('data-variant-id');
    var oldPlan = line.getAttribute('data-plan-id') || '';
    var props = {};
    try {
      props = JSON.parse(line.getAttribute('data-properties') || '{}') || {};
    } catch (e) {
      props = {};
    }
    var sig = propsSig(props);
    return change(keys[0], qty, { selling_plan: plan }).then(function (res) {
      if (keys.length < 2 || !res || !res.items) return res;
      var left = {};
      res.items.forEach(function (i) {
        var p = i.selling_plan_allocation ? String(i.selling_plan_allocation.selling_plan.id) : '';
        if (i.variant_id === vid && p === oldPlan && propsSig(i.properties) === sig) left[i.key] = 0;
      });
      return Object.keys(left).length ? update({ updates: left }) : res;
    });
  }
  // Codes and the free gift don't combine, and Shopify keeps whichever saves more
  function giftHeld() {
    var b = body();
    return !!(b && b.getAttribute('data-gift-key') && b.getAttribute('data-gift-free') === 'true');
  }
  function giftWord() {
    return String(config().giftLabel || 'free gift').toLowerCase();
  }

  function act(el) {
    var action = el.getAttribute('data-bs-action');
    var line = lineOf(el);
    var key = line && line.getAttribute('data-key');
    var qty = line ? +line.getAttribute('data-qty') : 0;
    var refocus = line ? { variant: line.getAttribute('data-variant-id'), action: action } : null;

    switch (action) {
      case 'inc':
        return run(function () {
          return setQty(line, qty + 1);
        }, line, refocus);
      case 'dec':
        if (qty <= 1) return removeLine(line);
        return run(function () {
          return setQty(line, qty - 1);
        }, line, refocus);
      case 'remove':
        return removeLine(line);
      case 'toggle-sub':
        var plan = line.getAttribute('data-plan-id') ? null : +line.getAttribute('data-default-plan');
        return run(function () {
          return replan(line, plan);
        }, line, refocus);
      case 'add':
        return run(function () {
          return add([{ id: +el.getAttribute('data-variant'), quantity: 1 }]).then(keepNewKey);
        }, null);
      case 'upgrade':
        var fromKey = el.getAttribute('data-from-key');
        var fromLine = lineWithKey(fromKey);
        var fromKeys = fromLine ? keysOf(fromLine) : [fromKey];
        return run(function () {
          return add([
            { id: +el.getAttribute('data-variant'), quantity: 1, selling_plan: +el.getAttribute('data-plan') }
          ])
            .then(keepNewKey)
            .then(function () {
              return clearLines(fromKeys);
            });
        }, fromLine);
      case 'claim-gift':
        return claimGift(el);
      case 'remove-code':
        return removeCode(el.getAttribute('data-code'));
      case 'undo':
        return undo();
    }
  }

  /* Free gift (claim button): add the option picked on the claim card, marked as the gift */
  function claimGift(btn) {
    var card = btn.closest('[data-bs-claim]');
    var pick = card && q('[data-bs-claim-variant]', card);
    var id = pick ? +pick.value : 0;
    if (!id) return;
    return run(function () {
      return add([{ id: id, quantity: 1, properties: { _bs_gift: '1' } }]).then(keepNewKey);
    }, null);
  }
  /* Swap the claimed gift for another option (a different coffee in the tin) */
  function swapGift(select) {
    var line = lineOf(select);
    if (!line) return;
    var oldKey = line.getAttribute('data-key');
    var id = +select.value;
    if (!id || String(id) === line.getAttribute('data-variant-id')) return;
    return run(function () {
      return add([{ id: id, quantity: 1, properties: { _bs_gift: '1' } }])
        .then(keepNewKey)
        .then(function () {
          return change(oldKey, 0);
        });
    }, line);
  }

  function removeLine(line) {
    var item = lineItem(line);
    var title = line.getAttribute('data-title') || 'item';
    var keys = keysOf(line);
    return run(function () {
      return clearLines(keys);
    }, line).then(function (ok) {
      if (!ok) return;
      state.removed = item;
      toast('Removed ' + title + '.', true);
    });
  }
  function undo() {
    var item = state.removed;
    if (!item) return;
    hideToast();
    return run(function () {
      return add([item]).then(keepNewKey);
    });
  }
  function toast(text, withUndo) {
    var t = q('[data-bs-toast]');
    if (!t) return;
    t.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = text;
    t.appendChild(span);
    if (withUndo) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-bs-action', 'undo');
      btn.textContent = 'Undo';
      t.appendChild(btn);
    }
    t.hidden = false;
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(expireToast, 4000);
    if (withUndo) {
      setTimeout(function () {
        var b = q('[data-bs-action="undo"]', t);
        if (b && drawerVisible()) b.focus({ preventScroll: true });
      }, 60);
    }
  }
  // The notice goes after 4 seconds, but waits while a mouse is over it or a keyboard user is on Undo
  function expireToast() {
    var t = q('[data-bs-toast]');
    if (!t || t.hidden) return;
    var d = drawer();
    var hovered = window.matchMedia('(hover: hover) and (pointer: fine)').matches && t.matches(':hover');
    var keyboardOnUndo = d && !d.classList.contains('bs-pointer') && t.contains(document.activeElement);
    if (hovered || keyboardOnUndo) {
      state.toastTimer = setTimeout(expireToast, 1500);
      return;
    }
    hideToast();
  }
  function hideToast() {
    var t = q('[data-bs-toast]');
    clearTimeout(state.toastTimer);
    state.removed = null;
    if (!t || t.hidden) return;
    var hadFocus = t.contains(document.activeElement);
    t.hidden = true;
    t.innerHTML = '';
    if (hadFocus) {
      var title = q('.bs-head__title');
      if (title) title.focus({ preventScroll: true });
    }
  }

  /* ---------- discount codes ---------- */
  function currentCodes() {
    return qa('[data-bs-code]').map(function (el) {
      return el.getAttribute('data-bs-code');
    });
  }
  function codeApplies(res, code) {
    var wanted = code.toLowerCase();
    if (Array.isArray(res.discount_codes)) {
      return res.discount_codes.some(function (d) {
        return String(d.code).toLowerCase() === wanted && d.applicable;
      });
    }
    var text = JSON.stringify([res.cart_level_discount_applications || [], (res.items || []).map(function (i) {
      return i.line_level_discount_allocations || [];
    })]).toLowerCase();
    return text.indexOf('"title":"' + wanted + '"') > -1;
  }
  function applyCode(input) {
    var code = ((input && input.value) || '').trim();
    if (!code) {
      codeError('Pop a code in first.');
      if (input) input.focus();
      return;
    }
    var codes = currentCodes();
    var onAlready = qa('[data-bs-code]').filter(function (el) {
      return el.getAttribute('data-bs-code').toLowerCase() === code.toLowerCase();
    })[0];
    if (onAlready) {
      codeError(
        onAlready.classList.contains('is-off')
          ? 'That code’s already on, but it doesn’t work with what’s in your cart right now.'
          : 'That code is already on.'
      );
      return;
    }
    return run(function () {
      return update({ discount: codes.concat(code).join(',') }).then(function (res) {
        if (codeApplies(res, code)) {
          tidyCodeCookie(res);
          state.codeAccepted = true;
          return res;
        }
        state.codeValue = code;
        if (!codes.length) {
          state.codeError = giftHeld()
            ? 'Codes don’t combine with your ' + giftWord() + ', and the ' + giftWord() + ' saves you more, so we’ve kept it. Remove the ' + giftWord() + ' if you’d rather use the code.'
            : 'That code doesn’t work with what’s in your cart.';
          return update({ discount: '' });
        }
        // With other codes on, check whether it works by itself: if so, it's those it can't be
        // combined with (Brightside's codes don't combine), so say so rather than "doesn't work".
        return update({ discount: code }).then(function (alone) {
          state.codeError = codeApplies(alone, code)
            ? 'That code can’t be used with ' + codes.join(' or ') + '. Remove ' +
              (codes.length > 1 ? 'those' : 'it') + ' to use this one instead.'
            : 'That code doesn’t work with what’s in your cart.';
          return update({ discount: codes.join(',') });
        });
      });
    });
  }
  function removeCode(code) {
    var codes = currentCodes().filter(function (c) {
      return c.toLowerCase() !== String(code).toLowerCase();
    });
    return run(function () {
      return update({ discount: codes.join(',') }).then(function (res) {
        tidyCodeCookie(res);
        return res;
      });
    });
  }
  // A code from a link (brightside.coffee/discount/CODE) is also saved in a discount_code cookie,
  // which checkout applies again even after it's been taken off the cart. So once the drawer has
  // set the codes, drop that cookie if it holds a code the cart no longer has.
  function tidyCodeCookie(res) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m || !res || !Array.isArray(res.discount_codes)) return;
    var kept = res.discount_codes.map(function (d) {
      return String(d.code).toLowerCase();
    });
    var saved = '';
    try {
      saved = decodeURIComponent(m[1]);
    } catch (e) {
      saved = m[1];
    }
    var stale = saved.split(',').some(function (c) {
      c = c.trim().toLowerCase();
      return c && kept.indexOf(c) === -1;
    });
    if (stale) document.cookie = 'discount_code=; Max-Age=0; path=/';
  }

  // Shopify only applies shipping discounts at checkout, so a free-shipping code (FLIPPNSHIPPN)
  // never appears in cart.discount_applications and the Liquid can't see it. The cart's
  // discount_codes list does have it, with an "applicable" flag that tracks the cart (false on a
  // subscription-only cart, or alongside a code it can't be combined with). Any code on that list
  // without a pill gets one here: an applicable one is a shipping code, so it reads "Free
  // shipping" and the drawer shows shipping as free; one that doesn't apply is shown greyed out
  // with the reason, rather than vanishing.
  function refreshCodes() {
    // Opening the cart and an add-to-cart arrive together, so one fetch covers both
    clearTimeout(state.codesTimer);
    state.codesTimer = setTimeout(function () {
      var seq = ++state.codesSeq;
      fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (cart) {
          if (!cart || seq !== state.codesSeq || state.busy) return;
          state.codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
          syncCodes();
        })
        .catch(function () {});
    }, 50);
  }
  function syncCodes() {
    var codes = state.codes || [];
    qa('[data-bs-code-extra]').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    var shown = qa('[data-bs-code]').map(function (el) {
      return el.getAttribute('data-bs-code').toLowerCase();
    });
    var extras = codes.filter(function (d) {
      return d && d.code && shown.indexOf(String(d.code).toLowerCase()) === -1;
    });
    var ship = extras.filter(function (d) {
      return d.applicable;
    })[0];
    state.shipCode = ship ? String(ship.code).toUpperCase() : null;

    var box = q('.bs-code');
    var tpl = q('[data-bs-code-tpl]');
    if (box && tpl && tpl.content && extras.length) {
      var pills = q('.bs-code__pills', box);
      if (!pills) {
        pills = document.createElement('div');
        pills.className = 'bs-code__pills';
        pills.setAttribute('data-bs-code-extra', '');
        box.insertBefore(pills, box.firstChild);
      }
      var off = [];
      extras.forEach(function (d) {
        var code = String(d.code).toUpperCase();
        var pill = tpl.content.firstElementChild.cloneNode(true);
        pill.setAttribute('data-bs-code', code);
        if (!d.applicable) {
          pill.classList.add('is-off');
          off.push(code);
        }
        q('[data-bs-code-text]', pill).textContent = code + ' · ' + (d.applicable ? 'Free shipping' : 'Not applied');
        var btn = q('[data-bs-action="remove-code"]', pill);
        btn.setAttribute('data-code', code);
        btn.setAttribute('aria-label', 'Remove code ' + code);
        pills.appendChild(pill);
      });
      if (off.length) {
        var others = codes
          .filter(function (d) {
            return d.applicable;
          })
          .map(function (d) {
            return String(d.code).toUpperCase();
          });
        var hint = document.createElement('p');
        hint.className = 'bs-code__hint';
        hint.setAttribute('data-bs-code-extra', '');
        hint.textContent = others.length
          ? off.join(' and ') + (off.length > 1 ? ' don’t' : ' doesn’t') + ' combine with ' + others.join(' or ') + '.'
          : giftHeld()
            ? off.join(' and ') + (off.length > 1 ? ' don’t' : ' doesn’t') + ' combine with your ' + giftWord() + ', and the ' +
              giftWord() + ' saves you more, so we’ve kept it. Remove the ' + giftWord() + ' if you’d rather use the code.'
            : off.join(' and ') + (off.length > 1 ? ' don’t' : ' doesn’t') + ' work with what’s in your cart right now.';
        pills.parentNode.insertBefore(hint, pills.nextSibling);
      }
    }
    paintShipCode();
  }
  function paintShipCode() {
    var code = state.shipCode;
    var c = config();
    var b = body();
    var total = b ? +b.getAttribute('data-total') || 0 : 0;

    // Free shipping bar: "Free shipping with CODE" instead of "$X away from free shipping"
    var bar = q('[data-bs-bar]');
    var msg = bar && q('[data-bs-bar-msg]', bar);
    var on = !!code && total < c.freeAt;
    if (msg) {
      if (on) {
        if (!msg.hasAttribute('data-bs-orig')) msg.setAttribute('data-bs-orig', msg.innerHTML);
        msg.innerHTML = '';
        var strong = document.createElement('strong');
        strong.textContent = 'Free shipping';
        msg.appendChild(strong);
        msg.appendChild(document.createTextNode(' with ' + code + '. Nice one.'));
      } else if (msg.hasAttribute('data-bs-orig')) {
        msg.innerHTML = msg.getAttribute('data-bs-orig');
        msg.removeAttribute('data-bs-orig');
      }
    }
    if (bar) {
      // The track is about spending to $75, which no longer matters (unless it's also counting to the gift)
      bar.classList.toggle('is-code', on && !(c.giftOn && c.giftAt > c.freeAt));
      var sticker = q('[data-bs-sticker]', bar);
      if (sticker) sticker.classList.toggle('is-on', on || bar.getAttribute('data-reached') === 'true');
    }

    // Suggestion heading: drop the free-shipping pitch while the code covers it
    qa('[data-bs-head-code]').forEach(function (el) {
      if (!el.hasAttribute('data-bs-head')) el.setAttribute('data-bs-head', el.textContent);
      el.textContent = code ? el.getAttribute('data-bs-head-code') : el.getAttribute('data-bs-head');
    });

    // Shipping, total, Afterpay: free with the code, otherwise back to the live rate
    var sig = b && b.getAttribute('data-sig');
    var label = q('[data-bs-ship-label]');
    if (code) paintShip(0, null);
    else if (sig && state.rates[sig]) applyRates(state.rates[sig]);
    else if (label && label.textContent !== 'Shipping') {
      // The code just came off without a re-render: put the real rate back
      label.textContent = 'Shipping';
      fetchRates();
    }
  }

  // iPhones zoom the whole page in when a box with text under 16px is tapped. The code and note
  // boxes use 16px text; the delivery frequency picker stays small, so on iPhone Safari is asked
  // not to auto-zoom just while it's being used (people can still pinch-zoom on iPhone).
  var IOS = /iP(hone|od|ad)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function noAutoZoom(on) {
    var meta = q('meta[name="viewport"]');
    if (!meta) return;
    if (on) {
      if (!meta.hasAttribute('data-bs-content')) meta.setAttribute('data-bs-content', meta.getAttribute('content') || '');
      var base = meta.getAttribute('data-bs-content').replace(/,?\s*maximum-scale=[^,]*/i, '');
      meta.setAttribute('content', (base ? base + ', ' : '') + 'maximum-scale=1');
    } else if (meta.hasAttribute('data-bs-content')) {
      meta.setAttribute('content', meta.getAttribute('data-bs-content'));
      meta.removeAttribute('data-bs-content');
    }
  }

  /* ---------- order note, frequency ---------- */
  function saveNote(value) {
    clearTimeout(state.noteTimer);
    state.noteTimer = setTimeout(function () {
      post('cart/update.js', { note: value }, false).catch(function () {});
    }, 500);
  }
  function changePlan(select) {
    var line = lineOf(select);
    if (!line) return;
    return run(
      function () {
        // An empty value is the "One-off instead" option: drop the subscription.
        return replan(line, select.value ? +select.value : null);
      },
      line,
      { variant: line.getAttribute('data-variant-id'), select: true }
    );
  }

  /* ---------- live shipping rates ---------- */
  function rateCents(rate) {
    return Math.round(parseFloat(rate.price) * 100);
  }
  function applyRates(rates) {
    if (!rates || !rates.length) return;
    // Mixed carts get one "Standard" rate per delivery profile (one-off + Seal subscription);
    // checkout adds them together into a single Standard line, so add them up here too.
    var standards = rates.filter(function (r) {
      return String(r.name).trim().toLowerCase() === 'standard';
    });
    var ship;
    if (standards.length) {
      ship = standards.reduce(function (sum, r) {
        return sum + rateCents(r);
      }, 0);
    } else {
      ship = rates
        .map(rateCents)
        .sort(function (a, b) {
          return a - b;
        })[0];
    }
    var b = body();
    var c = config();
    if (
      c.singleCharge &&
      b &&
      b.getAttribute('data-has-ot') === 'true' &&
      b.getAttribute('data-has-sub') === 'true' &&
      ship > 990
    ) {
      ship = 990;
    }
    var express = rates.filter(function (r) {
      return /express/i.test(r.name);
    })[0];
    paintShip(ship, express);
  }
  function paintShip(ship, express) {
    // A free-shipping code beats the rate (the express upsell goes too, as there's nothing to upsell)
    var code = state.shipCode;
    if (code) {
      ship = 0;
      express = null;
    }
    var label = q('[data-bs-ship-label]');
    if (label) label.textContent = code ? 'Shipping · ' + code : 'Shipping';

    qa('[data-bs-ship]').forEach(function (shipEl) {
      shipEl.textContent = ship === 0 ? 'FREE' : money(ship);
      shipEl.classList.toggle('is-free', ship === 0);
    });
    var expEl = q('[data-bs-express]');
    var expRow = q('[data-bs-express-row]');
    if (expEl && express) expEl.textContent = money(rateCents(express));
    if (expRow) expRow.hidden = !express;

    var totalEl = q('[data-bs-total]');
    if (!totalEl) return;
    var grand = +totalEl.getAttribute('data-cart-total') + ship;
    totalEl.textContent = money(grand);
    qa('[data-bs-total-inline]').forEach(function (el) {
      el.textContent = money(grand);
    });
    var ap = q('[data-bs-afterpay]');
    if (ap) ap.textContent = money(Math.floor(grand / 4));
    var note = q('[data-bs-ship-note]');
    if (note) note.textContent = ship === 0 ? 'Free shipping' : 'Incl. ' + money(ship) + ' shipping';
  }
  function fetchRates() {
    var b = body();
    if (!b || b.getAttribute('data-empty') === 'true') return;
    var sig = b.getAttribute('data-sig');
    if (state.rates[sig]) {
      applyRates(state.rates[sig]);
      return;
    }
    var seq = ++state.ratesSeq;
    var poll = function (n) {
      return fetch(rootUrl() + 'cart/async_shipping_rates.json?' + RATE_ADDRESS, { credentials: 'same-origin' })
        .then(function (r) {
          return r.status === 200 ? r.json() : null;
        })
        .then(function (json) {
          if (seq !== state.ratesSeq) return;
          if (json && json.shipping_rates) {
            state.rates[sig] = json.shipping_rates;
            applyRates(json.shipping_rates);
            return;
          }
          if (n < 12) {
            return wait(400 + n * 100).then(function () {
              return poll(n + 1);
            });
          }
        });
    };
    fetch(rootUrl() + 'cart/prepare_shipping_rates.json?' + RATE_ADDRESS, {
      method: 'POST',
      credentials: 'same-origin'
    })
      .then(function () {
        return poll(0);
      })
      .catch(function () {});
  }

  /* ---------- dispatch countdown (Perth time) ---------- */
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }
  function perthNow() {
    var now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() + 480) * 60000);
  }
  function ymd(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }
  function updateDispatch() {
    var el = q('[data-bs-dispatch-text]');
    if (!el) return;
    var c = config();
    var closed = String(c.closed || '')
      .split(/[\s,]+/)
      .filter(Boolean);
    var isOpen = function (d) {
      var day = d.getDay();
      return day > 0 && day < 6 && closed.indexOf(ymd(d)) === -1;
    };
    var now = perthNow();
    var mins = now.getHours() * 60 + now.getMinutes();
    var cutoff = (parseInt(c.cutoffHour, 10) || 11) * 60;
    if (isOpen(now) && mins < cutoff) {
      var left = cutoff - mins;
      var h = Math.floor(left / 60);
      var m = left % 60;
      el.innerHTML = 'Order in <strong>' + (h ? h + 'h ' : '') + m + 'm</strong>, ships today';
      return;
    }
    var next = null;
    var i;
    for (i = 1; i <= 21; i++) {
      next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
      if (isOpen(next)) break;
    }
    var label =
      i === 1
        ? 'tomorrow'
        : next.toLocaleDateString('en-AU', i < 7 ? { weekday: 'long' } : { weekday: 'long', day: 'numeric', month: 'short' });
    el.innerHTML = 'Ships <strong>' + label + '</strong>';
  }

  /* ---------- the van and the $75 moment ---------- */
  // Replays the bar from the old spend to the new one so the van visibly drives there,
  // even when the cart changed while the drawer was closed (add to cart from a product page).
  function driveTrack(fromPct, forwards) {
    var fill = q('[data-bs-fill]');
    var van = q('[data-bs-van]');
    if (reduceMotion()) return;
    var replay = typeof fromPct === 'number';
    var from = Math.max(0, Math.min(100, fromPct || 0)) + '%';
    if (fill && replay) {
      var fillTo = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = from;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = fillTo;
    }
    if (van) {
      if (replay) {
        var vanTo = van.style.left;
        van.style.transition = 'none';
        van.style.left = from;
        void van.offsetWidth;
        van.style.transition = '';
        van.style.left = vanTo;
      }
      if (forwards) {
        van.classList.remove('is-driving');
        void van.offsetWidth;
        van.classList.add('is-driving');
        setTimeout(function () {
          van.classList.remove('is-driving');
        }, 700);
      }
    }
  }

  function celebrate(which) {
    var marker = q('[data-bs-marker="' + which + '"]');
    var sticker = q('.bs-sticker');
    if (!marker || reduceMotion()) return;

    // If they've scrolled down the cart, bring the bar back into view for the moment.
    var bar = q('.bs-bar');
    var b = body();
    if (bar && b && bar.getBoundingClientRect().top < b.getBoundingClientRect().top) {
      b.scrollTo({ top: 0, behavior: 'smooth' });
    }

    var stickerWasOn = sticker && sticker.classList.contains('is-on');
    if (stickerWasOn) sticker.classList.remove('is-on');

    setTimeout(function () {
      marker.classList.remove('is-pop');
      void marker.offsetWidth;
      marker.classList.add('is-pop');
      if (stickerWasOn && sticker.isConnected) sticker.classList.add('is-on');

      var fx = document.createElement('span');
      fx.className = 'bs-fx';
      fx.setAttribute('aria-hidden', 'true');
      fx.style.left = marker.style.left;
      CONFETTI.forEach(function (p) {
        var bit = document.createElement('i');
        bit.style.cssText =
          '--dx:' + p[0] + 'px;--dy:' + p[1] + 'px;--r:' + p[2] + 'deg;background:' + p[3] +
          ';width:' + p[4] + 'px;height:' + p[5] + 'px;border-radius:' + p[6];
        fx.appendChild(bit);
      });
      if (marker.parentNode) marker.parentNode.appendChild(fx);
      setTimeout(function () {
        if (fx.parentNode) fx.parentNode.removeChild(fx);
        marker.classList.remove('is-pop');
      }, 1300);
    }, 480);
  }

  function whenVisible(fn, delay) {
    var tries = 0;
    (function check() {
      if (drawerVisible()) {
        setTimeout(fn, typeof delay === 'number' ? delay : 320);
        return;
      }
      if (++tries > 40) return;
      setTimeout(check, 50);
    })();
  }

  /* ---------- free gift tier ---------- */
  // Add automatically: the gift goes in once the cart's over the threshold. Claim button: the
  // shopper adds it from the claim card. Either way it comes out if the cart drops back under.
  function syncGift() {
    var c = config();
    if (!c.giftOn || state.busy || state.giftLock) return;
    var b = body();
    if (!b) return;
    var total = +b.getAttribute('data-total') || 0;
    var giftKey = b.getAttribute('data-gift-key');
    var giftFree = b.getAttribute('data-gift-free') === 'true';
    var codeOn = (+b.getAttribute('data-code-saved') || 0) > 0;
    var need = '';
    if (giftKey && total < c.giftAt) need = 'remove';
    // A code and the gift don't combine, and Shopify keeps whichever saves more. If that's the
    // code, the claimed gift is back at full price, so take it out rather than charge for it.
    else if (c.giftClaim && giftKey && !giftFree && codeOn) need = 'code-won';
    else if (!c.giftClaim && c.giftVariant && !giftKey && total >= c.giftAt) need = 'add';
    if (!need) return;
    state.giftLock = true;
    run(function () {
      return need === 'add'
        ? add([{ id: +c.giftVariant, quantity: 1, properties: { _bs_gift: '1' } }])
        : change(giftKey, 0);
    }, null, null, true).then(function (ok) {
      var label = giftWord();
      if (ok && need === 'remove' && c.giftClaim) {
        toast('Your ' + label + ' came out as your cart dropped under ' + money(c.giftAt).replace('.00', '') + '. Add ' + money(c.giftAt - total) + ' more to claim it again.');
      } else if (ok && need === 'code-won') {
        toast('Your code saves you more than the ' + label + ', and the two don’t combine, so we’ve taken the ' + label + ' out.');
      }
      setTimeout(function () {
        state.giftLock = false;
      }, 400);
    });
  }

  /* ---------- order summary (sits above the total) ---------- */
  // Open whenever the cart opens. On phones it folds away once the shopper scrolls the cart,
  // to give the items room; tapping the toggle overrides that for the rest of the visit.
  // The open state lives on the drawer itself, which the theme never re-renders.
  function syncSummary() {
    var d = drawer();
    var open = !!(d && d.classList.contains('is-sum-open'));
    qa('[data-bs-sum-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  function setSummary(open) {
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-sum-open', open);
    syncSummary();
  }
  function toggleSummary() {
    var d = drawer();
    if (!d) return;
    state.sumManual = !d.classList.contains('is-sum-open');
    setSummary(state.sumManual);
  }
  // Phones: if the open summary would leave the items less than ~40% of the screen (e.g. a
  // subscription cart, where Shopify adds consent text under the express buttons), start folded.
  function fitSummary() {
    if (state.sumManual !== null || window.innerWidth >= 768) return;
    var d = drawer();
    var b = body();
    var panel = q('.bs-sum-panel');
    var inner = q('.bs-sum-panel__inner');
    if (!d || !b || !panel || !inner || !d.classList.contains('is-sum-open')) return;
    var stillToOpen = Math.max(0, inner.scrollHeight - panel.getBoundingClientRect().height);
    if (b.clientHeight - stillToOpen < window.innerHeight * 0.4) setSummary(false);
  }
  function foldSummaryOnScroll(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-bs-body]')) return;
    if (state.sumManual !== null || window.innerWidth >= 768) return;
    var d = drawer();
    if (!d) return;
    if (d.classList.contains('is-sum-open')) {
      if (t.scrollTop < 24) return;
      // Only fold when the cart still needs scrolling afterwards. In a short cart, folding would
      // make everything fit at once: the cart would jump back to the top and stop scrolling.
      var panel = q('.bs-sum-panel');
      var gain = panel ? panel.getBoundingClientRect().height : 0;
      if (t.scrollHeight - t.clientHeight <= gain + 24) return;
      setSummary(false);
      state.sumScrolled = true;
    } else if (state.sumScrolled && t.scrollTop <= 0) {
      // Back at the top of a long cart: bring the summary back
      state.sumScrolled = false;
      setSummary(true);
    }
  }

  /* ---------- express checkout (wallet buttons folded under Checkout) ---------- */
  // Folded every time the cart opens; the open state lives on the drawer, which the theme never
  // re-renders, so it survives cart updates.
  function syncExpress() {
    var d = drawer();
    var open = !!(d && d.classList.contains('is-express-open'));
    qa('[data-bs-express-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Apple Pay only appears on Apple devices, so drop its icon everywhere else
    var apple = false;
    try {
      apple = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments());
    } catch (e) {
      apple = false;
    }
    qa('.bs-express__icon--apple_pay').forEach(function (el) {
      if (apple) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }
  function setExpress(open) {
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-express-open', open);
    // On phones, opening the wallets folds the order summary away so the items stay in view
    if (open && window.innerWidth < 768 && state.sumManual === null) setSummary(false);
    if (open) state.sumScrolled = false;
    syncExpress();
  }

  /* ---------- phones: hold the page still behind the cart ---------- */
  // On phones the cart covers the screen and the theme locks the page with overflow: hidden, but
  // iPhone Safari still lets a drag on the cart (or the keyboard coming up) scroll the page
  // underneath. So while the cart is open on a phone the page is pinned in place, and it goes
  // back exactly where it was when the cart closes. Desktop is left alone: there the cart sits
  // beside the page, which stays scrollable on purpose (snippets/right-drawer).
  // It's pinned once the cart has slid in and covers the page, and let go the moment the cart
  // starts to close, so the page is already back in place as the cart slides away: nothing jumps.
  var pageLock = null;
  var lockWatch = null;
  function cartOpen() {
    var store = window.Alpine && window.Alpine.store ? window.Alpine.store('modals') : null;
    return store && store.rightDrawer ? !!store.rightDrawer.open : drawerVisible();
  }
  function lockPage() {
    if (window.innerWidth >= 768 || (pageLock && pageLock.pinned)) return;
    pageLock = { pinned: false };
    whenVisible(pinPage, 320);
    var modal = document.getElementById('modals-rightDrawer');
    if (modal && window.MutationObserver) {
      lockWatch = lockWatch || new MutationObserver(checkLock);
      lockWatch.observe(modal, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
    }
  }
  function pinPage() {
    if (!pageLock || pageLock.pinned) return;
    if (!cartOpen()) {
      unlockPage();
      return;
    }
    var s = document.body.style;
    pageLock.y = window.scrollY || window.pageYOffset || 0;
    pageLock.css = s.cssText;
    pageLock.pinned = true;
    s.position = 'fixed';
    s.top = -pageLock.y + 'px';
    s.left = '0';
    s.right = '0';
    s.width = '100%';
    s.overflow = 'hidden';
  }
  function checkLock() {
    if (pageLock && !cartOpen()) unlockPage();
  }
  function unlockPage() {
    if (!pageLock) return;
    if (lockWatch) lockWatch.disconnect();
    var lock = pageLock;
    pageLock = null;
    if (!lock.pinned) return;
    document.body.style.cssText = lock.css;
    window.scrollTo(0, lock.y);
  }

  /* ---------- sale prices on products that aren't in the cart yet ---------- */
  // DECO's automatic discounts (e.g. BUNDLE40%) only show on a cart line once the product is in
  // the cart. For the empty-cart picks we work the price out from DECO's own rules (the shop
  // metafield scm_deco.discounts, printed by snippets/drawer-cart), the same rules DECO uses for
  // the sale prices on product and collection pages. Anything we can't check for certain
  // (customer-only deals, minimum spend, tag or title rules) is skipped, so we never show a
  // price the shopper won't get.
  var saleRules = null;
  function rules() {
    if (saleRules) return saleRules;
    try {
      saleRules = JSON.parse(document.getElementById('bs-sale-rules').textContent);
    } catch (e) {
      saleRules = [];
    }
    if (!Array.isArray(saleRules)) saleRules = [];
    return saleRules;
  }
  function listHas(list, value) {
    return Array.isArray(list) && list.map(String).indexOf(String(value)) > -1;
  }
  function salePrice(price, productId, variantId, collections) {
    var now = Date.now();
    var best = price;
    rules().forEach(function (r) {
      if (!r || r.code || r.discount_type !== 'automatic' || r.discount_classes !== 'product') return;
      if (!r.applies_on_one_time_purchase || r.eligibility_type !== 'all' || r.minimum_requirement_type !== 'none') return;
      if (r.starts_at && now < Date.parse(r.starts_at)) return;
      if (r.ends_at && now > Date.parse(r.ends_at)) return;
      var c = r.condition || {};
      var types = Array.isArray(c.condition_apply) ? c.condition_apply : [c.condition_apply];
      var inCollection = function (ids) {
        return (ids || []).some(function (id) {
          return listHas(collections, id);
        });
      };
      var applies =
        types.length > 0 &&
        types.every(function (t) {
          switch (t) {
            case 'all_product':
              return true;
            case 'specific_product':
              return listHas(c.specific_whole_products, productId) || listHas(c.specific_products, variantId);
            case 'specific_collection':
              return inCollection(c.specific_collections);
            case 'exclude_product':
              return !listHas(c.exclude_whole_products, productId) && !listHas(c.exclude_products, variantId);
            case 'exclude_collection':
              return !inCollection(c.exclude_collections);
            default:
              return false;
          }
        });
      if (!applies) return;
      var value = parseFloat(r.discount_value) || 0;
      var p = r.discount_apply === 'percentage' ? Math.round(price * (1 - value / 100)) : price;
      if (p < best) best = p;
    });
    return best;
  }
  function showSalePrices() {
    qa('[data-bs-sale]').forEach(function (el) {
      var price = +el.getAttribute('data-price');
      var was = Math.max(price, +el.getAttribute('data-compare') || 0);
      var collections = (el.getAttribute('data-collections') || '').split(',');
      var sale = salePrice(price, el.getAttribute('data-product'), el.getAttribute('data-variant'), collections);
      if (!(sale < price)) return;
      el.innerHTML = '<s><span class="sr-only">Was </span>' + money(was) + '</s><span>' + money(sale) + '</span>';
    });
  }

  /* ---------- after every cart re-render ---------- */
  function refocus() {
    var r = state.refocus;
    state.refocus = null;
    if (!r) return;
    var line = q('[data-bs-line][data-variant-id="' + attr(r.variant) + '"]');
    var target = line && (r.select ? q('[data-bs-frequency]', line) : q('[data-bs-action="' + r.action + '"]', line));
    if (target) target.focus({ preventScroll: true });
  }

  function afterRender(evt) {
    var b = body();
    if (!b) return;
    var c = config();
    var total = +b.getAttribute('data-total') || 0;
    var hasOt = b.getAttribute('data-has-ot') === 'true';
    var max = c.giftOn && c.giftAt > c.freeAt ? c.giftAt : c.freeAt;
    var prev = state.prevTotal;
    state.prevTotal = total;

    var key = state.flashKey;
    if (!key && evt && evt.type === 'shapes:cart:afteradditem' && evt.detail && evt.detail.response) {
      key = evt.detail.response.key;
    }
    state.flashKey = null;

    if (evt) {
      // If the drawer was already open, the re-render itself slides the bar and van along;
      // if it was closed, replay the drive once it's on screen.
      // (From an empty cart the bar is brand new, so it always gets the replay.)
      var seen = drawerVisible() && prev !== 0;
      var moved = prev !== null && hasOt && prev !== total;
      if (moved && seen) driveTrack(null, total > prev);
      whenVisible(function () {
        if (key && !reduceMotion()) {
          var li = lineWithKey(key);
          if (li) {
            li.classList.remove('is-new');
            void li.offsetWidth;
            li.classList.add('is-new');
          }
        }
        if (moved) {
          if (!seen) driveTrack((prev / max) * 100, total > prev);
          if (prev < c.freeAt && total >= c.freeAt) celebrate('ship');
          else if (c.giftOn && prev < c.giftAt && total >= c.giftAt) celebrate('gift');
        }
      }, seen ? 0 : 320);
    }

    var details = q('[data-bs-note-details]');
    if (details && state.noteOpen !== null) details.open = state.noteOpen;
    syncSummary();
    syncExpress();
    if (drawerVisible()) fitSummary();
    if (state.codeAccepted) {
      // The code's on (its pill shows above the box), so empty the box (the re-render keeps what
      // was typed while it has focus) and put the phone keyboard away to show the new total
      state.codeAccepted = false;
      var usedInput = q('[data-bs-code-form] input');
      if (usedInput) {
        usedInput.value = '';
        usedInput.removeAttribute('value');
        if (document.activeElement === usedInput) usedInput.blur();
      }
    }
    if (state.codeError) {
      // Keep the rejected code in the box so a typo can be fixed rather than retyped. The theme
      // resets every cart input to its value attribute after a re-render, so set both.
      var codeInput = q('[data-bs-code-form] input');
      if (codeInput && state.codeValue) {
        codeInput.setAttribute('value', state.codeValue);
        codeInput.value = state.codeValue;
      }
      codeError(state.codeError);
      state.codeError = '';
    }
    state.codeValue = '';
    showSalePrices();
    // Codes Shopify doesn't list in the Liquid (a free-shipping code): straight away from what we
    // last knew, so nothing flickers, then from the cart unless we've just been told
    syncCodes();
    if (state.codesFresh) state.codesFresh = false;
    else if (evt || drawerVisible()) refreshCodes();
    refocus();
    updateDispatch();
    if (evt || drawerVisible()) fetchRates();
    syncGift();
  }

  /* ---------- wiring ---------- */
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-bs-action]') : null;
      if (!el || !el.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      if (el.disabled) return;
      act(el);
    },
    true
  );
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-bs-sum-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      toggleSummary();
    },
    true
  );
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-bs-express-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      var d = drawer();
      setExpress(!(d && d.classList.contains('is-express-open')));
    },
    true
  );
  if (IOS) {
    document.addEventListener(
      'touchstart',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('.bs-drawer .bs-freq')) noAutoZoom(true);
      },
      { capture: true, passive: true }
    );
    document.addEventListener(
      'focusout',
      function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-bs-frequency]')) {
          setTimeout(function () {
            noAutoZoom(false);
          }, 400);
        }
      },
      true
    );
  }
  // Opening the order note puts the cursor straight in the box. Done inside the tap itself
  // so phones bring the keyboard up.
  document.addEventListener(
    'click',
    function (e) {
      var summary = e.target && e.target.closest ? e.target.closest('[data-bs-note-details] > summary') : null;
      if (!summary) return;
      var details = summary.parentNode;
      if (details.open) return;
      e.preventDefault();
      details.open = true;
      state.noteOpen = true;
      var box = q('[data-bs-note]', details);
      if (box) box.focus();
    },
    true
  );
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-bs-code-form]')) return;
      e.preventDefault();
      applyCode(q('input', form));
    },
    true
  );
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-bs-frequency]')) changePlan(t);
      else if (t && t.matches && t.matches('[data-bs-gift-swap]')) swapGift(t);
    },
    true
  );
  document.addEventListener(
    'input',
    function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('[data-bs-note]')) saveNote(t.value);
      else if (t.matches('[data-bs-code-form] input') && e.isTrusted) codeError('');
    },
    true
  );
  document.addEventListener(
    'toggle',
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-bs-note-details]')) state.noteOpen = t.open;
    },
    true
  );

  ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update'].forEach(function (name) {
    window.addEventListener(name, function (e) {
      setTimeout(function () {
        afterRender(e);
      }, 0);
    });
  });
  document.addEventListener('scroll', foldSummaryOnScroll, { capture: true, passive: true });
  // Focus rings are for keyboard users. After a tap or click (where iPhone Safari would otherwise
  // ring the element we re-focus after an update) the drawer hides them until a key is pressed.
  document.addEventListener(
    'pointerdown',
    function () {
      var d = drawer();
      if (d) d.classList.add('bs-pointer');
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Tab' && e.key.indexOf('Arrow') !== 0) return;
      var d = drawer();
      if (d) d.classList.remove('bs-pointer');
    },
    true
  );
  document.addEventListener('theme:cart-drawer:opening', function () {
    lockPage(); // phones only
    hideToast(); // never reopen the cart on an old "Removed" notice
    setExpress(false);
    state.sumScrolled = false;
    if (state.sumManual === null) {
      // Phones start with the summary folded, so the coffee gets the room; the tab above the
      // total opens it and shows what they're saving. Bigger screens start with it open.
      setSummary(window.innerWidth >= 768);
      whenVisible(fitSummary, 30);
    }
    updateDispatch();
    afterRender(null);
    // Pick up a code added elsewhere since (an email link, another tab)
    refreshCodes();
    fetchRates();
  });

  config();
  state.prevTotal = typeof cfg.initialTotal === 'number' ? cfg.initialTotal : null;
  updateDispatch();
  showSalePrices();
  syncExpress();
  setInterval(updateDispatch, 30000);

  window.BrightsideCart = {
    config: config,
    refreshRates: fetchRates,
    celebrate: celebrate
  };
})();
